import Image from 'next/image';
import styles from './TreatmentFeedBack.module.css';
import { ICaseStudyDetails } from '@/interfaces';
type props = {
    caseStudyData: ICaseStudyDetails
}
export function TreatmentFeedBack({ caseStudyData }: props) {
    return (
        <section className="mb30">
            <div className="container">
                <h2 className="sectionHeading">Patient Feedback</h2>
                <div className={`${styles.formSection} mb30`}>
                    <div className={`${styles.formContent} ${styles.backgroundddf5eb}`}>
                        <div className={styles.feedback}>
                            <Image src="/assets/images/feedback-quote.png" width={96} height={96} alt="" className="mb10" />
                            <p className="font16 fontsm14 lineHeight30 fontRegular">{caseStudyData?.patient_quote}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}